import { useEffect, useState } from "react";
import "./index.scss";
import CustomScroll from '@src/component/customScroll'
import { Toast, Image, ImageViewer } from 'antd-mobile'
import BottomIcon from "@src/component/bottomIcon";
import { getQueryParams } from "@src/util";
import { getVehicleList } from '@src/service/applyFormSubService'
import VehicleSelector from "@src/component/VehicleSelector";
import { goto } from "@src/route";
import { hasLoanAndQuaStatus } from "@src/service/ownService";
import store from '@src/util/store'
import p1 from '@src/assets/image/1.png'
import p2 from '@src/assets/image/2.png'
import p3 from '@src/assets/image/3.png'
import p4 from '@src/assets/image/4.png'

export type ConfigVosType = {
    id: number,
    configName: string,
    materialsCode: string,
    salePrice: number,
    vehicleFullName: string,
    vehicleImg?: string
}
interface Preview {
    url?: string
    show: boolean
    upload?: string
}
export default function Index() {
    const [motoInfo, setMotoInfo] = useState<any>();
    const [motoVis, setMotoVis] = useState<boolean>(false);
    const [showPreview, setShowPreview] = useState<Preview>({ url: undefined, show: false, upload: undefined })
    useEffect(() => {
        document.title = "分期方案";
    }, [])
    useEffect(() => {
        if (store.get('cheliang')) {
            setMotoInfo(store.get('cheliang'));
        }
        getVehicleList().then(res => {
            //意向车型变量
            const data = getQueryParams();
            const vt: Array<ConfigVosType> = [];
            res.forEach((r: { colorAndConfigVos: any[] }) => {
                r.colorAndConfigVos.forEach(cc => {
                    cc.configVos.forEach((c: ConfigVosType) => {
                        vt.push(c)
                    })
                })
            });
            const vItem = vt.find(v => v.materialsCode == data.vtc  /**"6KJC-N1A0C4-B51N"*/);
            if (vItem) {
                store.set('cheliang', vItem)
                setMotoInfo(vItem);
            } else {
                store.set('cheliang', vt[0])
                setMotoInfo(vt[0])
            }

        }).catch(err => {
            Toast.show(err?.errmsg || '获取车型失败')
        })
    }, [])

    // 回显摩托型号
    const setMooteData = (obj: any) => {
        store.set('cheliang', obj)
        setMotoInfo(obj);
        setMotoVis(false);
    }

    /**
     * 1、首付=车辆价格*10%
     * 2、【（车辆价格-首付）*(8.2%/12)*最多期数）+（车辆价格-首付）】/最多期数
     * 3、3万以内，最多24期；3万及以上，最多36期
     * @param {number} price
     * @return
     */
    const calc = (price: number) => {
        if (price <= 0) {
            return {
                monthPay: 0,
                stage: 0
            }
        }
        const stage = 18;
        // 计算月租金额  融租金额 * （1 + 年化费率 / 12 * 期数）/ 期数,
        const monthPay = price * (1 + 0.098 / 12 * stage) / stage || 0;
        return { monthPay: monthPay.toFixed(2), stage }
    }

    // 查看一个预审状态
    const quaResult = async () => {
        try {
            Toast.show({
                icon: 'loading',
                content: '加载中…',
                duration: 0,
                maskClickable: false
            })
            const { code } = await hasLoanAndQuaStatus() || {};
            Toast.clear()
            if (code === 999) {
                Toast.show('您已有业务办理成功，暂不支持新的业务办理')
            }
            // 当前无业务
            else if ([0, 1, 2, 3, 4, 9].includes(code)) {
                goto('/rzStatus');
            }
            // 进入资格预审
            else {
                goto("/uploadId");
            }
        } catch (err: any) {
            Toast.show(err?.errmsg || '状态查询失败')
        }
    }

    return (<div className="page bottomFit rzIndex">
    <CustomScroll>
        <div className="rzIndex-headImg">
            <Image src={motoInfo?.vehicleImg} onClick={() => {setShowPreview({url: motoInfo?.vehicleImg, show: true}) }} fit="contain" />
        </div>
        <section>
            <div className="rzIndex-picker">
                {motoInfo?.vehicleFullName &&
                    <p>{motoInfo?.vehicleFullName}</p>
                }
                <div className="rzIndex-check">
                    {
                        motoInfo?.salePrice &&
                        <h2>{motoInfo?.salePrice || 0}</h2>
                    }
                    <div onClick={() => { setMotoVis(true) }}><i /></div>
                </div>
            </div>
            <div className="rzIndex-calBox">
                <div className="rzIndex-calculbox">
                    <div className="calcul-title">
                        <h2 className="dotted-line">参考分期方案</h2>
                        <span>（最终方案以实际审核为准）</span>
                    </div>
                    <div onClick={() => {
                        goto("/rzIndex/calculator")
                    }} className="rzIndex-calcul">
                        金融计算器
                        <i />
                    </div>
                </div>
                <div className="detailInfo">
                    <div className="detailInfo-box">
                        <div className="rzIndex-label">
                            首付
                        </div>
                        <p>
                            0
                            <span>元</span>
                        </p>
                    </div>
                    <div className="detailInfo-box">
                        <div className="rzIndex-label">
                            月租
                        </div>
                        <p>
                            {calc(motoInfo?.salePrice).monthPay}
                            <span>元起</span>
                        </p>
                    </div>
                    <div className="detailInfo-box">
                        <div className="rzIndex-label">
                            期数
                        </div>
                        <p>
                            <span>最多</span>
                            {calc(motoInfo?.salePrice).stage}
                            <span>期</span>
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <footer>
            <div className="rzIndex-cause">
                <div className="rzIndex-whyCheck dotted-line">为什么选择分期？</div>
                <ul>
                    <li className="cause-box">
                        <img src={p1} alt="" className="serial"></img>
                        <div className="describe">
                            <p>多</p>
                            <span>6、12、18期任选</span>
                        </div>
                    </li>
                    <li className="cause-box">
                        <img src={p2} alt="" className="serial"></img>
                        <div className="describe">
                            <p>快</p>
                            <span>全线上操作</span>
                            <span>流程简单极速办理</span>
                        </div>
                    </li>
                    <li className="cause-box">
                        <img src={p3} alt="" className="serial"></img>
                        <div className="describe">
                            <p>好</p>
                            <span>ZEEHO</span>
                            <span>全系车型均可分期购</span>
                        </div>
                    </li>
                    <li className="cause-box">
                        <img src={p4} alt="" className="serial"></img>
                        <div className="describe">
                        <p>省</p>
                        <span>超低月租</span>
                        <span>畅享美好生活</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div onClick={quaResult} className="button-them upload-next">资格预审</div>
            <BottomIcon />
            <VehicleSelector onClose={() => { setMotoVis(false) }} onConfirm={setMooteData} visible={motoVis} />
        </footer>
    </CustomScroll>
    <ImageViewer
        image={showPreview.url}
        visible={showPreview.show}
        onClose={() => {
            setShowPreview({show: false})
        }}
    />
</div>)
}
